import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';

import Table from '../../../components/table/Table';
import TBody from '../../../components/table/TBody/TBody';
import TD from '../../../components/table/TD/TD';
import TH from '../../../components/table/TH/TH';
import THead from '../../../components/table/THead/THead';
import TR from '../../../components/table/TR/TR';
import { RootState } from '../../../core/state/state';
import { getSubcontractorNotificationEmailSettings } from '../../../core/state/subcontractors/asyncActions';
import EditNotificationsMailModal from '../modals/edit-notifications-mail/EditNotificationsMailModal';
import TableWrapper from '../../components/table-wrapper/TableWrapper';
import ActionDropdown from '../../../components/action-dropdown/ActionDropdown';

const ExternalUserNotificationEmails: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isEditModalOpen, setIsEditModalOpen] = React.useState<boolean>(false);
  const externalUserData = useSelector((state: RootState) => state.subcontractor.subcontractorNotificationEmail);
  const subcontractorId = useSelector((state: RootState) => state.user.userInfo?.userID);
  const [selectedId, setSelectedId] = React.useState<number | undefined>(undefined);

  React.useEffect(() => {
    if (subcontractorId) {
      dispatch(getSubcontractorNotificationEmailSettings(subcontractorId));
    }
  }, [dispatch, subcontractorId]);

  return (
    <TableWrapper>
      <div className="table__header">
        <span>{t('sidebar.link.notificationsEmails')}</span>
      </div>
      <Table>
        <THead>
          <TR>
            <TH>{t('common.projectName')}</TH>
            <TH>{t('common.projectNumber')}</TH>
            <TH>
              {t('common.contactPerson')}({t('common.forNotifications')})
            </TH>
            <TH>
              {t('common.email')} {t('common.forNotifications')}
            </TH>
          </TR>
        </THead>
        <TBody>
          {externalUserData?.map((d) => (
            <TR key={d.id}>
              <TD>{d.projectName}</TD>
              <TD>{d.projectCode}</TD>
              <TD>{d.notificationsContactName}</TD>
              <TD>{d.notificationsEmail}</TD>
              <TD className="pr-2">
                <ActionDropdown>
                  <Dropdown.Item
                    onClick={() => {
                      setSelectedId(d.id);
                      setIsEditModalOpen(true);
                    }}
                  >
                    {t('common.edit')}
                  </Dropdown.Item>
                </ActionDropdown>
              </TD>
            </TR>
          ))}
        </TBody>
      </Table>
      <EditNotificationsMailModal key={selectedId} selectedId={selectedId} isOpen={isEditModalOpen} closeModal={() => setIsEditModalOpen(false)} />
    </TableWrapper>
  );
};

export default ExternalUserNotificationEmails;
